import {
  ExclamationCircleOutlined,
  InfoCircleOutlined,
  LinkOutlined,
  UploadOutlined,
} from '@ant-design/icons'
import { Button, Card, Form, Input, Tooltip, Upload } from 'antd'
import React from 'react'
import ContentHeader from '../shared/ContentHeader'

const AppPushTemplates = ({
  pushData,
  handleChange,
  handleImageChange,
  headerTitle,
}) => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          background: '#fff',
        }}
      >
        <ContentHeader title={headerTitle} />
      </div>

      <Card
        title={
          <>
            <InfoCircleOutlined style={{ marginRight: 8 }} />
            템플릿 이름 <span style={{ color: 'red' }}>*</span>
          </>
        }
        style={{ marginBottom: 20 }}
      >
        <Form.Item
          label="템플릿 이름"
          required
          style={{ marginBottom: 16 }}
          labelCol={{ flex: '0 0 100px' }}
          wrapperCol={{ flex: '1 1 auto' }}
          labelAlign="left"
        >
          <Input
            name="title"
            placeholder="템플릿 이름을 입력하세요"
            value={pushData.title}
            onChange={handleChange}
            maxLength={50}
            style={{ width: '50%' }}
          />
        </Form.Item>
      </Card>

      <Card
        title={
          <>
            <InfoCircleOutlined style={{ marginRight: 8 }} />
            푸시 내용 <span style={{ color: 'red' }}>*</span>
          </>
        }
        style={{ marginBottom: 20 }}
      >
        <Form.Item
          label="제목"
          required
          style={{ marginBottom: 16 }}
          labelCol={{ flex: '0 0 100px' }}
          wrapperCol={{ flex: '1 1 auto' }}
          labelAlign="left"
        >
          <Input
            name="pushTitle"
            placeholder="푸시 알림 제목을 입력하세요"
            value={pushData.pushTitle}
            onChange={handleChange}
            maxLength={50}
            style={{ width: '50%' }}
          />
        </Form.Item>

        <Form.Item
          label="내용"
          required
          style={{ marginBottom: 16 }}
          labelCol={{ flex: '0 0 100px' }}
          wrapperCol={{ flex: '1 1 auto' }}
          labelAlign="left"
        >
          <Input.TextArea
            name="pushBody"
            placeholder="푸시 알림 내용을 입력하세요"
            value={pushData.pushBody}
            onChange={handleChange}
            maxLength={200}
            style={{ width: '50%' }}
            rows={4}
          />
        </Form.Item>

        <Form.Item
          label="URL"
          style={{ marginBottom: 16 }}
          labelCol={{ flex: '0 0 100px' }}
          wrapperCol={{ flex: '1 1 auto' }}
          labelAlign="left"
        >
          <Input
            name="pushUrl"
            prefix={<LinkOutlined />}
            placeholder="연결될 URL을 입력하세요 (선택사항)"
            value={pushData.pushUrl}
            onChange={handleChange}
            style={{ width: '50%' }}
          />
          <Tooltip
            title="푸시 클릭 시 연결될 URL을 입력하세요. 푸시 클릭 시 해당 URL로 이동합니다. 경로가 올바르지 않을 경우 이동하지 않습니다.
          URL 발송 전 꼭 개발팀에 확인해주세요!"
          >
            <ExclamationCircleOutlined
              style={{
                color: 'red',
                fontSize: '20px',
                cursor: 'help',
                marginLeft: '10px',
              }}
            />
          </Tooltip>
        </Form.Item>

        <Form.Item
          label="이미지"
          style={{ marginBottom: 0 }}
          labelCol={{ flex: '0 0 100px' }}
          wrapperCol={{ flex: '1 1 auto' }}
          labelAlign="left"
        >
          <div style={{ width: '25vw', minWidth: 200 }}>
            <Upload
              name="image"
              maxCount={1}
              listType="picture"
              accept="image/png"
              beforeUpload={(file) => {
                const isPNG = file.type === 'image/png'
                if (!isPNG) {
                  alert('PNG 파일만 업로드 가능합니다!')
                }
                return false
              }}
              onChange={handleImageChange}
              // 새로 등록할 때, 수정할 때 구분하기 위함
              fileList={
                pushData.pushImageUrl?.originFileObj
                  ? [pushData.pushImageUrl]
                  : typeof pushData.pushImageUrl === 'string'
                    ? [
                        {
                          uid: '-1',
                          name: 'image.png',
                          status: 'done',
                          url: pushData.pushImageUrl,
                        },
                      ]
                    : []
              }
              style={{
                width: '100%',
                minWidth: 200,
              }}
            >
              <Button
                style={{
                  width: '200px',
                  height: '200px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                }}
              >
                <UploadOutlined style={{ fontSize: '24px' }} />
                <span>이미지 선택&nbsp;</span>
                <span style={{ fontSize: '12px', color: '#666' }}>
                  (png 형식 필수)
                </span>
                <span style={{ fontSize: '8px', color: '#666' }}>
                  png형식이 가장 덜 깨집니다.
                </span>
              </Button>
            </Upload>
          </div>
        </Form.Item>
      </Card>
    </>
  )
}

export default AppPushTemplates
